import MainDispatcher from '../support/MainDispatcher';

export default {
  setDate: function (start, end) {
    MainDispatcher.dispatch({ action: 'ANALYTICS_DATE_CHANGED', start, end });
  },
  setShowBy: function (showBy) {
    MainDispatcher.dispatch({
      action: 'ANALYTICS_SHOW_BY_CHANGED',
      showBy: showBy,
    });
  },
};
